"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var logs;
        (function (logs) {
            var index;
            (function (index) {
                class InitArgs {
                    constructor() {
                        this.includesDescription = false;
                        this.isPopup = false;
                    }
                }
                let _initArgs;
                let _dataTable = null;
                let _historyDataTable = null;
                let totalTables = 0;
                function init(args) {
                    _initArgs = args;
                    createDataTable();
                    addEvents();
                }
                index.init = init;
                function addEvents() {
                    $('.toggle-history').click(function () {
                        const tr = $(this).closest('tr');
                        const $rowOptions = $(this).closest('.rowOptions');
                        const $icon = $(this).find('i');
                        if (_dataTable.fnIsOpen(tr)) {
                            _dataTable.fnClose(tr);
                            appn.ui.handleParentResize(0, 50);
                            $icon.removeClass('fa-chevron-up').addClass('fa-history').attr('title', T('show history'));
                            $rowOptions.removeClass('d-inline');
                            return;
                        }
                        totalTables += 1;
                        const html = tr.find('.history-table-container').html();
                        const childRow = _dataTable.fnOpen(tr, html, 'info_row');
                        $(childRow).addClass('history-table-show_' + totalTables.toString());
                        createHistoryDataTable();
                        $icon.removeClass('fa-history').addClass('fa-chevron-up').attr('title', T('hide history'));
                        $rowOptions.addClass('d-inline');
                    });
                }
                function createHistoryDataTable() {
                    _historyDataTable = appn.dataTable.create('.history-table-show_' + totalTables.toString() + ' table', {
                        sDom: appn.dataTable.genSDom(0, 0, 0),
                        scrollY: null,
                        searching: false,
                        paging: false,
                        info: false,
                        bSort: false,
                        ordering: false,
                        hasFilters: false,
                        aoColumns: [
                            { bSortable: false, sWidth: '20%' },
                            { bSortable: false, sWidth: '25%' },
                            { bSortable: false, sWidth: '15%' },
                            { bSortable: false, sWidth: '40%' }
                        ],
                        fnInitComplete: function () {
                            appn.ui.handleParentResize(0, 50);
                        }
                    });
                }
                function createDataTable() {
                    _dataTable = appn.dataTable.create('.logs-table', {
                        scrollY: null,
                        iDisplayLength: 50,
                        paging: false,
                        bSort: false,
                        ordering: false,
                        hasFilters: false,
                        searching: !_initArgs.isPopup,
                        aoColumns: getColumnConfig(),
                        fnInitComplete: function () {
                            if (!_initArgs.isPopup)
                                appn.dataTable.addSearchPlaceholder(T(`Filter results where the Log's <b>Rows or Columns</b> contain a keyword typed in here.`), appn.emptyString, 'left');
                        }
                    });
                }
                function getColumnConfig() {
                    if (_initArgs.includesDescription)
                        return [
                            { bSortable: false, sWidth: '20%' },
                            { bSortable: false, sWidth: '10%' },
                            { bSortable: false, sWidth: '15%' },
                            { bSortable: false, sWidth: '15%' },
                            { bSortable: false, sWidth: '40%' }
                        ];
                    return [
                        { bSortable: false, sWidth: '20%' },
                        { bSortable: false, sWidth: '20%' },
                        { bSortable: false, sWidth: '20%' },
                        { bSortable: false, sWidth: '40%' }
                    ];
                }
            })(index = logs.index || (logs.index = {}));
        })(logs = views.logs || (views.logs = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
